import React, { useState, useEffect } from 'react';
import { Script, ScriptStrategy } from 'gatsby';

const TrackingScripts: React.FC = () => {
    const [loadScripts, setLoadScripts] = useState(false);

    useEffect(() => {
        const handleInteraction = (): void => {
            React.startTransition(() => {
                setLoadScripts(true);
            });
            window.removeEventListener('scroll', handleInteraction);
            window.removeEventListener('mousemove', handleInteraction);
            window.removeEventListener('touchstart', handleInteraction);
        };

        window.addEventListener('scroll', handleInteraction, { once: true });
        window.addEventListener('mousemove', handleInteraction, { once: true });
        window.addEventListener('touchstart', handleInteraction, { once: true });

        return () => {
            window.removeEventListener('scroll', handleInteraction);
            window.removeEventListener('mousemove', handleInteraction);
            window.removeEventListener('touchstart', handleInteraction);
        };
    }, []);

    return loadScripts ? (
        <Script
            src="//cdn.bc0a.com/autopilot/f00000000209368/autopilot_sdk.js"
            strategy={ScriptStrategy.postHydrate}
        />
    ) : null;
};

export default TrackingScripts;
